import { render, staticRenderFns } from "./UserIntegral.vue?vue&type=template&id=4d3f7c52&scoped=true&"
import script from "./UserIntegral.vue?vue&type=script&lang=js&"
export * from "./UserIntegral.vue?vue&type=script&lang=js&"
import style0 from "./UserIntegral.vue?vue&type=style&index=0&id=4d3f7c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f7c52",
  null
  
)

component.options.__file = "UserIntegral.vue"
export default component.exports